import { Alert } from '@gravity-ui/uikit';
import { InternalVideoDocUrl } from '../consts/InternalVideoDocURL';
import { pageT } from '../../../i18n/page.i18n';

type InternalVideoPromoAlertProps = {
    visibility: boolean;
    onClose: () => void;
};

export function InternalVideoPromoAlert({ visibility, onClose }: InternalVideoPromoAlertProps) {
    return (
        <Alert
            className={'promo'}
            style={{
                display: visibility ? 'block' : 'none',
            }}
            theme="utility"
            title={pageT('promoAlertTitle')}
            message={
                <>
                    {pageT('promoAlertIntro')}
                    <ul style={{ margin: 0, paddingLeft: '2em' }}>
                        <li>{pageT('promoAlertTeamVideos')}</li>
                        <li>{pageT('promoAlertImportantMeetings')}</li>
                    </ul>
                </>
            }
            onClose={onClose}
            actions={
                <Alert.Action href={InternalVideoDocUrl} target="_blank" view="outlined-utility">
                    {pageT('promoAlertAction')}
                </Alert.Action>
            }
        />
    );
}
